var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.587794 11.5979C1.95139 9.06276 3.48784 7.1422 7.90514 7.33426C7.98196 7.33426 8.0972 7.44949 8.0972 7.52631V9.44687C8.0972 9.58131 8.28925 9.83099 8.48131 9.63893L13.6092 5.29846C13.686 5.24084 13.686 5.12561 13.6092 5.06799L8.48131 0.996396C8.38528 0.919573 8.0972 0.996396 8.0972 1.18845V3.10902C8.0972 3.18584 7.98196 3.30107 7.90514 3.30107C0.222887 4.0693 0.626205 10.023 0.338121 11.4635C0.299709 11.6171 0.510971 11.7323 0.587794 11.5979Z",
    fill: "#999CAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ab6039fe2b0d5b8fac028a1c44dca4f2.svg";
export { ForwardRef as ReactComponent };